export const maximumMessageTitleCount = 75;
export const maximumMessageCount = 150;

export const messageClassValue = {
  PUSH_NOTIFICATIONS: 3,
  ALL_MESSAGES: 1,
  IN_APP_MESSAGES: 2,
};
